export default "__VITE_ASSET__Bk$cApWU__"